const Dashboard = () => {
    return (
      <div>
        <h1>Dashboard</h1>
        <p>Welcome to the Admin Engine</p>
      </div>
    )
  }
  
  export default Dashboard